import { useGetIdentity } from "@refinedev/core";
import { IIdentity } from "../interfaces";

export const usePermissions = () => {
  const { data: user, isLoading } = useGetIdentity<IIdentity>();

  // If user is not loaded yet, default to limited access
  if (!user || isLoading) {
    return {
      isFounder: false,
      isAdmin: false,
      hasFullAccess: false,
      hasLimitedAccess: true,
      user: null,
      isLoading: isLoading || !user,
    };
  }

  const isFounder = user?.type === "FOUNDER";
  const isAdmin = user?.is_admin === true;
  
  // User has full access if they are a FOUNDER or admin
  const hasFullAccess = isFounder || isAdmin;
  
  // User has limited access (only dashboard and logout)
  const hasLimitedAccess = !hasFullAccess;



  return {
    isFounder,
    isAdmin,
    hasFullAccess,
    hasLimitedAccess,
    user,
    isLoading: false,
  };
}; 